import { Button, Image } from "antd";
import { LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, ToolOutlined } from "@ant-design/icons";
import { useAuth } from "../ProtectedRoute/PrivateRoutes";
import { Link, useNavigate } from "react-router-dom";
import { useAppContext } from "../../hooks/useAppContext";

export default function HeaderComponent() {
  const { onLogout, authState } = useAuth();
  const { menuCollapsed, setMenuCollapsed } = useAppContext()
  const navigate = useNavigate();
  return (
    <div style={{ backgroundColor: '#fbfbfb', borderRadius: 15, paddingLeft: 10, paddingRight: 10, minHeight: 50, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 20, boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 20 }}>
        <Link to='/'>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
            <img src={require('../../assets/books.png')} alt='logo' style={{
              width: 50, height: 50, 
              filter: 'drop-shadow(0 0 10px rgba(0, 0, 0, 0.5))'
            }} />
          </div>
        </Link>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 20 }}>
        <Button type='text' icon={menuCollapsed ? <MenuUnfoldOutlined style={{ fontSize: 20 }} /> : <MenuFoldOutlined style={{ fontSize: 20 }} />} onClick={() => setMenuCollapsed(!menuCollapsed)} />
      </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 20 }}>
        <div style={{ alignSelf: 'flex-start', float: 'left' }}>
          <Image preview={false} src={require('../../assets/avatar.png')} height={40} width={40} onClick={() => {
            navigate('/profile')
          }} style={{ alignSelf: 'flex-end', cursor: 'pointer', boxShadow: '1px 2px 9px gray', borderRadius: '50%' }} />
        </div>
          {
            authState?.is_admin &&
            <div>
              <Button onClick={() => {
                navigate('/admin')
              }} type="text" icon={<ToolOutlined />} style={{ marginRight: 10, boxShadow: '1px 2px 9px gray' }}></Button>
            </div>
          }
        <div>
          <Button onClick={() => {
            onLogout();
          }} type="text" icon={<LogoutOutlined />} style={{ marginRight: 10, boxShadow: '1px 2px 9px gray' }} />
        </div>
      </div>
    </div>
  );
}